import store from '@/state/store'

const sideMenu = [
  {
    id: 1,
    label: 'report.sideNav.all',
    icon: 'icon-outline_keypad',
    section: 'all',
    total: 0,
  },
  {
    id: 2,
    label: 'report.sideNav.favorites',
    icon: 'icon-outline_star',
    section: 'favorite',
    total: 0,
    hidden: !store.getters['identity/hasAccess'](['favorite-reports:read']),
  },
  {
    id: 3,
    label: 'report.sideNav.saved',
    icon: 'icon-outline_bookmark',
    section: 'saved',
    total: 0,
    hidden: !store.getters['identity/hasAccess'](['saved-reports:read']),
  },
  {
    id: 4,
    label: 'global.field.category',
    isTitle: true,
  },
  {
    id: 5,
    label: 'master.kendaraan',
    icon: 'icon-outline_car',
    section: 'fleet',
    total: 0,
  },
  {
    id: 6,
    label: 'menuitems.delivery.text',
    icon: 'icon-outline_cube',
    section: 'delivery',
    total: 0,
    hidden: !store.getters['identity/hasAccessAll']([
      'tms:create',
      'tms:read',
      'tms:update',
      'tms:delete',
    ]),
  },
  {
    id: 7,
    label: 'global.driver',
    icon: 'icon-outline_driver',
    section: 'driver',
    total: 0,
  },
]

export default sideMenu
